module.exports = __webpack_public_path__ + "img/snapchat.14528c25.svg";